// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root MuiContainer-maxWidthSm"
      >
        <div
          class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-1 MuiStepper-alternativeLabel MuiPaper-elevation0"
        >
          <div
            class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
          >
            <span
              class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
            >
              <span
                class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                  />
                  <text
                    class="MuiStepIcon-text"
                    text-anchor="middle"
                    x="12"
                    y="16"
                  >
                    1
                  </text>
                </svg>
              </span>
              <span
                class="MuiStepLabel-labelContainer"
              >
                <span
                  class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
                >
                  Select claims
                </span>
              </span>
            </span>
          </div>
          <div
            class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
          >
            <div
              class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
            >
              <span
                class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
              />
            </div>
            <span
              class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
            >
              <span
                class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiStepIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                  />
                  <text
                    class="MuiStepIcon-text"
                    text-anchor="middle"
                    x="12"
                    y="16"
                  >
                    2
                  </text>
                </svg>
              </span>
              <span
                class="MuiStepLabel-labelContainer"
              >
                <span
                  class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
                >
                  Invoice details
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div
        class="MuiContainer-root MuiContainer-maxWidthMd"
      >
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-justify-xs-center"
        >
          <form
            action="/patients/undefined/printable_invoice"
            id="hidden-private-invoice-form"
            method="POST"
            target="_blank"
          >
            <input
              id="private-invoice-form-params"
              name="invoice"
              type="hidden"
              value="{\\"user\\":{\\"name\\":\\"user name\\",\\"address1\\":\\"\\",\\"address2\\":\\"\\",\\"city\\":\\"\\",\\"province\\":\\"\\",\\"postalCode\\":\\"\\",\\"email\\":\\"\\",\\"phone\\":\\"\\"},\\"patient\\":{\\"name\\":\\"patient name\\",\\"address1\\":\\"patient address\\",\\"address2\\":\\"\\",\\"city\\":\\"patient city\\",\\"province\\":\\"patient province\\",\\"postalCode\\":\\"patient postalCode\\",\\"country\\":\\"patient country\\"},\\"invoiceDetails\\":{\\"number\\":\\"\\",\\"terms\\":\\"Payment is due 30 days after invoice date. Payment method is below. See payment stub for details.\\",\\"date\\":1466424490000},\\"claims\\":[]}"
            />
          </form>
          <div
            class="MuiGrid-root MuiGrid-item"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
            >
              <div
                class="MuiGrid-root MuiGrid-item"
              >
                <h2
                  class="MuiTypography-root MuiTypography-h2"
                >
                  Select claims to include
                </h2>
                <p
                  class="MuiTypography-root MuiTypography-body1"
                >
                  The private billing amounts shown are the advised rates from 
                  BCMA
                  .
                </p>
              </div>
              <div
                class="MuiGrid-root MuiGrid-item"
              >
                <div
                  class="MuiTableContainer-root"
                >
                  <table
                    aria-label="enhanced table"
                    aria-labelledby="tableTitle"
                    class="MuiTable-root makeStyles-table-6"
                  >
                    <thead
                      class="MuiTableHead-root"
                    >
                      <tr
                        class="MuiTableRow-root MuiTableRow-head"
                      >
                        <th
                          class="MuiTableCell-root MuiTableCell-head MuiTableCell-paddingCheckbox"
                          scope="col"
                        >
                          <span
                            aria-disabled="false"
                            class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-10 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                          >
                            <span
                              class="MuiIconButton-label"
                            >
                              <input
                                class="PrivateSwitchBase-input-13"
                                data-indeterminate="false"
                                type="checkbox"
                                value=""
                              />
                              <svg
                                aria-hidden="true"
                                class="MuiSvgIcon-root"
                                focusable="false"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                                />
                              </svg>
                            </span>
                            <span
                              class="MuiTouchRipple-root"
                            />
                          </span>
                        </th>
                        <th
                          class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignLeft MuiTableCell-paddingNone"
                          scope="col"
                        >
                          Status
                        </th>
                        <th
                          class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                          scope="col"
                        >
                          Date of service
                        </th>
                        <th
                          class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                          scope="col"
                        >
                          Code
                        </th>
                        <th
                          class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignLeft"
                          scope="col"
                        >
                          Description
                        </th>
                        <th
                          class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                          scope="col"
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      class="MuiTableBody-root"
                    >
                      <tr
                        aria-checked="false"
                        class="MuiTableRow-root MuiTableRow-hover"
                        role="checkbox"
                        tabindex="-1"
                      >
                        <td
                          class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-paddingCheckbox"
                        >
                          <span
                            aria-disabled="false"
                            class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-10 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                          >
                            <span
                              class="MuiIconButton-label"
                            >
                              <input
                                aria-labelledby="enhanced-table-checkbox-0"
                                class="PrivateSwitchBase-input-13"
                                data-indeterminate="false"
                                type="checkbox"
                                value=""
                              />
                              <svg
                                aria-hidden="true"
                                class="MuiSvgIcon-root"
                                focusable="false"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                                />
                              </svg>
                            </span>
                            <span
                              class="MuiTouchRipple-root"
                            />
                          </span>
                        </td>
                        <th
                          class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-paddingNone"
                          id="enhanced-table-checkbox-0"
                          role="cell"
                          scope="row"
                        >
                          status
                        </th>
                        <td
                          class="MuiTableCell-root MuiTableCell-body makeStyles-dateCell-9 MuiTableCell-alignRight"
                        >
                          20 Jun 2016
                        </td>
                        <td
                          class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-alignRight"
                        >
                          A
                        </td>
                        <td
                          class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7"
                        >
                          <div
                            class="MuiFormControl-root MuiTextField-root"
                          >
                            <div
                              class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                            >
                              <input
                                aria-invalid="false"
                                class="MuiInputBase-input MuiInput-input"
                                name="description"
                                type="text"
                                value="desc"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-alignRight"
                        >
                          <div
                            class="MuiFormControl-root MuiTextField-root"
                          >
                            <div
                              class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                            >
                              <input
                                aria-invalid="false"
                                class="MuiInputBase-input MuiInput-input"
                                name="privateBillingAmount"
                                style="text-align: right;"
                                type="text"
                                value="1.00"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
              >
                <div
                  class="MuiCardActions-root MuiCardActions-spacing"
                >
                  <button
                    class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-disableElevation"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiButton-label"
                    >
                      Cancel
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                  <button
                    class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-disableElevation"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiButton-label"
                    >
                      Next
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root MuiContainer-maxWidthSm"
    >
      <div
        class="MuiPaper-root MuiStepper-root MuiStepper-horizontal makeStyles-root-1 MuiStepper-alternativeLabel MuiPaper-elevation0"
      >
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  1
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiStepLabel-active MuiTypography-body2 MuiTypography-displayBlock"
              >
                Select claims
              </span>
            </span>
          </span>
        </div>
        <div
          class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel"
        >
          <div
            class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled"
          >
            <span
              class="MuiStepConnector-line WithStyles(ForwardRef(StepConnector))-line-4 MuiStepConnector-lineHorizontal"
            />
          </div>
          <span
            class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled makeStyles-disabled-3 MuiStepLabel-alternativeLabel"
          >
            <span
              class="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiStepIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                />
                <text
                  class="MuiStepIcon-text"
                  text-anchor="middle"
                  x="12"
                  y="16"
                >
                  2
                </text>
              </svg>
            </span>
            <span
              class="MuiStepLabel-labelContainer"
            >
              <span
                class="MuiTypography-root MuiStepLabel-label makeStyles-label-2 MuiStepLabel-alternativeLabel MuiTypography-body2 MuiTypography-displayBlock"
              >
                Invoice details
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div
      class="MuiContainer-root MuiContainer-maxWidthMd"
    >
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-justify-xs-center"
      >
        <form
          action="/patients/undefined/printable_invoice"
          id="hidden-private-invoice-form"
          method="POST"
          target="_blank"
        >
          <input
            id="private-invoice-form-params"
            name="invoice"
            type="hidden"
            value="{\\"user\\":{\\"name\\":\\"user name\\",\\"address1\\":\\"\\",\\"address2\\":\\"\\",\\"city\\":\\"\\",\\"province\\":\\"\\",\\"postalCode\\":\\"\\",\\"email\\":\\"\\",\\"phone\\":\\"\\"},\\"patient\\":{\\"name\\":\\"patient name\\",\\"address1\\":\\"patient address\\",\\"address2\\":\\"\\",\\"city\\":\\"patient city\\",\\"province\\":\\"patient province\\",\\"postalCode\\":\\"patient postalCode\\",\\"country\\":\\"patient country\\"},\\"invoiceDetails\\":{\\"number\\":\\"\\",\\"terms\\":\\"Payment is due 30 days after invoice date. Payment method is below. See payment stub for details.\\",\\"date\\":1466424490000},\\"claims\\":[]}"
          />
        </form>
        <div
          class="MuiGrid-root MuiGrid-item"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
          >
            <div
              class="MuiGrid-root MuiGrid-item"
            >
              <h2
                class="MuiTypography-root MuiTypography-h2"
              >
                Select claims to include
              </h2>
              <p
                class="MuiTypography-root MuiTypography-body1"
              >
                The private billing amounts shown are the advised rates from 
                BCMA
                .
              </p>
            </div>
            <div
              class="MuiGrid-root MuiGrid-item"
            >
              <div
                class="MuiTableContainer-root"
              >
                <table
                  aria-label="enhanced table"
                  aria-labelledby="tableTitle"
                  class="MuiTable-root makeStyles-table-6"
                >
                  <thead
                    class="MuiTableHead-root"
                  >
                    <tr
                      class="MuiTableRow-root MuiTableRow-head"
                    >
                      <th
                        class="MuiTableCell-root MuiTableCell-head MuiTableCell-paddingCheckbox"
                        scope="col"
                      >
                        <span
                          aria-disabled="false"
                          class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-10 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                        >
                          <span
                            class="MuiIconButton-label"
                          >
                            <input
                              class="PrivateSwitchBase-input-13"
                              data-indeterminate="false"
                              type="checkbox"
                              value=""
                            />
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root"
                          />
                        </span>
                      </th>
                      <th
                        class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignLeft MuiTableCell-paddingNone"
                        scope="col"
                      >
                        Status
                      </th>
                      <th
                        class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                        scope="col"
                      >
                        Date of service
                      </th>
                      <th
                        class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                        scope="col"
                      >
                        Code
                      </th>
                      <th
                        class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignLeft"
                        scope="col"
                      >
                        Description
                      </th>
                      <th
                        class="MuiTableCell-root MuiTableCell-head makeStyles-cell-7 MuiTableCell-alignRight"
                        scope="col"
                      >
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    class="MuiTableBody-root"
                  >
                    <tr
                      aria-checked="false"
                      class="MuiTableRow-root MuiTableRow-hover"
                      role="checkbox"
                      tabindex="-1"
                    >
                      <td
                        class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-paddingCheckbox"
                      >
                        <span
                          aria-disabled="false"
                          class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-10 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                        >
                          <span
                            class="MuiIconButton-label"
                          >
                            <input
                              aria-labelledby="enhanced-table-checkbox-0"
                              class="PrivateSwitchBase-input-13"
                              data-indeterminate="false"
                              type="checkbox"
                              value=""
                            />
                            <svg
                              aria-hidden="true"
                              class="MuiSvgIcon-root"
                              focusable="false"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                              />
                            </svg>
                          </span>
                          <span
                            class="MuiTouchRipple-root"
                          />
                        </span>
                      </td>
                      <th
                        class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-paddingNone"
                        id="enhanced-table-checkbox-0"
                        role="cell"
                        scope="row"
                      >
                        status
                      </th>
                      <td
                        class="MuiTableCell-root MuiTableCell-body makeStyles-dateCell-9 MuiTableCell-alignRight"
                      >
                        20 Jun 2016
                      </td>
                      <td
                        class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-alignRight"
                      >
                        A
                      </td>
                      <td
                        class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7"
                      >
                        <div
                          class="MuiFormControl-root MuiTextField-root"
                        >
                          <div
                            class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                          >
                            <input
                              aria-invalid="false"
                              class="MuiInputBase-input MuiInput-input"
                              name="description"
                              type="text"
                              value="desc"
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        class="MuiTableCell-root MuiTableCell-body makeStyles-cell-7 MuiTableCell-alignRight"
                      >
                        <div
                          class="MuiFormControl-root MuiTextField-root"
                        >
                          <div
                            class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                          >
                            <input
                              aria-invalid="false"
                              class="MuiInputBase-input MuiInput-input"
                              name="privateBillingAmount"
                              style="text-align: right;"
                              type="text"
                              value="1.00"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
            >
              <div
                class="MuiCardActions-root MuiCardActions-spacing"
              >
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-disableElevation"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Cancel
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
                <button
                  class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-disableElevation"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiButton-label"
                  >
                    Next
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
